import React from 'react';
import { ActionIcon, Box, Tooltip, rem, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { AnimatePresence, motion } from 'framer-motion';
import { DURATION, EASE_OUT } from '@/theme/motion';
import { TOUCH_TARGET, useIsTouch } from '@/hooks/use.responsive';
import useAppearance from '@/hooks/use.appearance';

const ShellThemeToggle: React.FC = () => {
    const { setColorScheme } = useMantineColorScheme();
    const { preferences, change } = useAppearance();
    const computed = useComputedColorScheme('dark', { getInitialValueInEffect: true });
    const isDark = computed === 'dark';
    const isTouch = useIsTouch();
    const label = isDark ? 'Passa al tema chiaro' : 'Passa al tema scuro';

    return (
        <Tooltip label={label}>
            <ActionIcon
                size={isTouch ? TOUCH_TARGET : 'lg'}
                variant="default"
                onClick={() => {
                    const next = isDark ? 'light' : 'dark';
                    if (preferences) change({ theme: next }); else setColorScheme(next);
                }}
                aria-label={label}
            >
                <Box style={{ position: 'relative', width: rem(19), height: rem(19) }}>
                    <AnimatePresence initial={false} mode="wait">
                        <motion.span
                            key={isDark ? 'sun' : 'moon'}
                            initial={{ opacity: 0, rotate: -70, scale: 0.6 }}
                            animate={{ opacity: 1, rotate: 0, scale: 1 }}
                            exit={{ opacity: 0, rotate: 70, scale: 0.6 }}
                            transition={{ duration: DURATION.base, ease: EASE_OUT }}
                            style={{ position: 'absolute', inset: 0, display: 'flex' }}
                        >
                            {isDark
                                ? <IconSun style={{ width: '100%', height: '100%' }} stroke={1.6} />
                                : <IconMoon style={{ width: '100%', height: '100%' }} stroke={1.6} />}
                        </motion.span>
                    </AnimatePresence>
                </Box>
            </ActionIcon>
        </Tooltip>
    );
};

export default ShellThemeToggle;
